import React  from "react";
import MUIDataTable from "mui-datatables";
import {
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";

import { Container, Row, Col } from "shards-react";
import axios from 'axios';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import api from '../../common/api';

class Brokers extends React.Component {

   constructor() {
      super();

      this.state = {
        data: '',
        isLoaded: false,
        brokers:[]
      }

    }

    async componentDidMount() {
      await this.getBrokers();
    }
   
   getBrokers(){
     const token =localStorage.getItem('userToken')

     return axios
              .get(api.insurances().brokers(),{ headers: {"Authorization" : `Bearer ${token}`} })
              .then(res => {
                this.setState({isLoaded: true,  brokers: res.data})
              })
              .catch(err =>{
                this.setState({isLoaded: true, brokers: [] })
              })
  }

  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
         root: {
           padding: '0px 8px 0px 8px',
           fontSize: '0.73rem'
          }
        }
      }
  });      


  render(){
     const columns = [
     {
      name: "id",
      label: "Id",
      options: {
       filter: false,
       sort: true,
      }
     },
     {
      name: "name",
      label: "Nombre",
      options: {
       filter: true,
       filterType: "textField",
       sort: true,
      }
     },
     {
      name: "provider.business_name",
      label: "Razon Social",
      options: {
       filter: true,
       filterType: "textField",
       sort: true,
      }
     }
    ];

  const options = {
    download: true,
    print:false,
    responsive: 'stacked',
    selectableRowsOnClick: true,
    rowsPerPage: 10,
    selectableRows: false,
    textLabels: {
          toolbar: {
            search: "Buscar",
            viewColumns: "Ver columnas",
            filterTable: "Filtros",   
            downloadCsv: "Exportar a CSV"        
          },
          body: {
              noMatch: this.state.isLoaded ?
                  'No hay resultados' :
                  <CircularProgress />,
          },
          selectedRows: {
            text: "fila(s) seleccionadas"
          },
          viewColumns: {
            title: "Ver columnas",
          },
          pagination: {
            next: "Siguiente",
            previous: "Anteior",
            rowsPerPage: "Cantidad por página:",
            displayRows: "de",      
          },
          filter: {
            all: "Todos",
            title: "Filtros",
            reset: "Limpiar"
          }
      }
  };

   return(
      <Container fluid className="main-content-container px-4">
          <Row>
            <Col className="p-2">
              <div>
               <MuiThemeProvider theme={this.getMuiTheme()}>
                <MUIDataTable
                title="Lista de Brokers"
                data={Object.values(this.state.brokers)}
                columns={columns}
                options={options}
               />
               <div style={{textAlign: "right"}}>
               <Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/contracts"}>
                  Volver
              </Button>
            </div>
          </MuiThemeProvider>
          </div>
        </Col>
      </Row>
     </Container>
    );
  }

}

export default Brokers;   